import { useMemo } from 'react';
import { ContactShadows } from '@react-three/drei';
import { useAppStore } from '@/state/store';

/**
 * The bat mesh is centered on its own bounding-box centroid (see
 * buildLatheGeometry), so its lowest point isn't a fixed Y — it depends on
 * the model's barrel radius. This positions the shadow plane at that exact
 * lowest point so the bat always reads as resting on the ground, for any
 * bat dimensions.
 */
export function GroundShadow() {
  const geometry = useAppStore((s) => s.geometry);

  const groundY = useMemo(() => {
    if (!geometry) return 0;
    geometry.computeBoundingBox();
    return geometry.boundingBox?.min.y ?? 0;
  }, [geometry]);

  const scale = useMemo(() => {
    if (!geometry) return 400;
    geometry.computeBoundingBox();
    const box = geometry.boundingBox;
    if (!box) return 400;
    return Math.max(200, (box.max.x - box.min.x) * 2);
  }, [geometry]);

  return (
    <ContactShadows
      position={[0, groundY, 0]}
      opacity={0.55}
      scale={scale}
      blur={2.4}
      far={scale}
      color="#000000"
    />
  );
}
